define('home/templates/relatedDiscussion',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"module-recent__media\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "\">\n<img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.src : stack1), depth0))
    + "\" class=\"img-fit-sm\" />\n</a>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"1 Comment",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"%(number)s Comments",{"name":"gettext","hash":{"number":((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.posts : stack1)},"data":data}))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.lambda, alias3=container.escapeExpression;

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"media-body\">\n<a href=\""
    + alias3(alias2((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "\" class=\"module-recent__title spacing-bottom-small\">\n<div class=\"spacing-bottom-narrow\">\n<h2 class=\"truncate\" data-truncate-lines=\"2\" dir=\"auto\">\n"
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.clean_title : stack1), depth0))
    + "\n</h2>\n</div>\n<p class=\"text-small text-gray\">\n"
    + ((stack1 = helpers["if"].call(alias1,helpers.eq.call(alias1,((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.posts : stack1),1,{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "</p>\n</a>\n</div>\n";
},"useData":true})

});
